import styled from 'react-emotion'
import { fontWeight, spacer } from 'stylist'

const SectionHeadline = styled.h1`
  max-width: 780px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${spacer(4)};
  text-align: center;

  ${fontWeight('bold')};
`

export default SectionHeadline



// WEBPACK FOOTER //
// ./src/routes/home/components/SectionHeadline.js